import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import './shell.css';

/**
 * Page header: breadcrumb (or a back affordance on drill-down screens), title,
 * subtitle, and a right-aligned primary action.
 */
export default function PageHeader({
  section,
  title,
  subtitle,
  back,
  backTo,
  primaryAction,
  actions,
}) {
  const navigate = useNavigate();

  return (
    <header className="sv-page-header">
      <div className="sv-page-header__text">
        {back ? (
          <button
            type="button"
            className="sv-page-header__back"
            onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
          >
            <i className="bx bx-arrow-back" aria-hidden="true" />
            Back to {back}
          </button>
        ) : (
          section && (
            <div className="sv-page-header__crumb">
              <span>{section}</span>
              <i className="bx bx-chevron-right" aria-hidden="true" />
              <span className="sv-page-header__crumb-current">{title}</span>
            </div>
          )
        )}

        <h1 className="sv-page-header__title">{title}</h1>
        {subtitle && <p className="sv-page-header__subtitle">{subtitle}</p>}
      </div>

      <div className="sv-page-header__actions">
        {actions}
        {primaryAction && (
          <Button variant="primary" icon={primaryAction.icon} onClick={primaryAction.onClick}>
            {primaryAction.label}
          </Button>
        )}
      </div>
    </header>
  );
}
